module.exports = __webpack_public_path__ + "static/8-3c0dc886e5ac76647b31e88e7ab12657.jpg";